import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { hcBlack, hcOrange } from '../../../../common/Constants'
import I18n from 'i18n'
import { initializeHighcharts, titleWithTooltip } from '../../../../common/Utils'
import GenericPlaceholder from '../../../../common/GenericPlaceholder'

class TrainingPeriodizationChart extends React.Component {
  constructor (props) {
    super(props)

    initializeHighcharts(true)
    this.state = {}
  }

  render () {
    if (!this.props.weeklySummary) {
      return (
        <GenericPlaceholder title={I18n.t('components.dashboards.questionnaire.training_periodization.title')} />
      )
    }
    const strainData = this.props.weeklySummary.map(entry => ({
      x: entry.date_only,
      y: entry.training_strain,
      training_monotony: entry.training_monotony,
      wknum: entry.wknum_formatted
    }))
    const loadData = this.props.weeklySummary.map(entry => ({
      x: entry.date_only,
      y: entry.training_load,
      wknum: entry.wknum_formatted
    }))
    return (
      <>
        <HighchartsReact
          highcharts={Highcharts}
          immutable
          options={{
            chart: { type: 'column' },
            title: titleWithTooltip(
              I18n.t('components.dashboards.questionnaire.training_periodization.title'),
              I18n.t('components.dashboards.questionnaire.training_periodization.info')
            ),
            subtitle: { text: I18n.t('components.dashboards.questionnaire.training_periodization.subtitle') },
            legend: { enabled: true },
            series: [
              {
                type: 'column',
                name: I18n.t('components.dashboards.questionnaire.training_periodization.series.strain', { defaultValue: 'Training Strain' }),
                data: strainData,
                color: hcBlack,
                stack: 'training',
                tooltip: { headerFormat: '', pointFormat: I18n.t('components.dashboards.questionnaire.training_periodization.area.tooltip') }
              },
              {
                type: 'column',
                name: I18n.t('components.dashboards.questionnaire.training_periodization.series.load', { defaultValue: 'Training Load' }),
                data: loadData,
                color: hcOrange,
                stack: 'training',
                tooltip: { headerFormat: '', pointFormat: I18n.t('components.dashboards.questionnaire.training_periodization.column.tooltip') }
              }
            ],
            xAxis: { title: { text: '' }, type: 'datetime', dateTimeLabelFormats: { day: '%d %b' } },
            yAxis: {
              title: { text: I18n.t('components.dashboards.questionnaire.training_periodization.yaxis') },
              min: 0,
              stackLabels: { enabled: true, formatter: function () { return Math.round(this.total) }, style: { fontWeight: 'bold' } }
            },
            plotOptions: { series: { stacking: 'normal', animation: false } },
            tooltip: { shared: false }
          }}
        />
      </>
    )
  }
}

export default TrainingPeriodizationChart
